<div class="container my-4">
  <div class="row">
    <div class="col-12">
      <span class="title_header_bar">Vumatel Product Mapping</span>
    </div>
  </div>
  <div class="card card_content">
    <div class="row d-flex justify-content-between align-items-center flex-wrap grid-margin">
      <div class="col-md-7">
        <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
          <i class="fa fa-refresh"></i> Refresh
        </button> -->
        <app-button (refreshClicked)="clearFilter()"></app-button>

        <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
          <i class="fa fa-file-excel"></i> Export
        </button>
      </div>
    </div>

    <div class="table-responsive mt-2 mb-4">
      <form [formGroup]="myForm">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
          
          <!-- HC Product Column -->
          <ng-container matColumnDef="HCProduct">
            <mat-header-cell *matHeaderCellDef mat-sort-header="HCProduct">HC Product</mat-header-cell>
            <mat-cell *matCellDef="let dataField" >
              <p class="text-truncate txtalign" >{{ dataField.VumatelProduct }}</p>
            </mat-cell>
          </ng-container>
    
          <!-- Vumatel Base Product Column -->
          <ng-container matColumnDef="VumatelBaseProduct">
            <mat-header-cell *matHeaderCellDef mat-sort-header="VumatelBaseProduct">VumatelBaseProduct</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
          <div class="col-xl-12">
            <mat-form-field appearance="fill" hideRequiredMarker>
                <mat-label>VumatelBaseProduct</mat-label>
                <mat-select class="scrollbarcs" [(ngModel)]="dataField.VumatelBaseProduct" [ngModelOptions]="{standalone: true}"
                    placeholder="Select Primary Product ">
                    <mat-select-filter [displayMember]="'value'" [array]="Vumatellist"
                    (filteredReturn)="filteredListMonthProduct = $event"></mat-select-filter>
                    <mat-option *ngFor="let item of filteredListMonthProduct" [value]="item"
                        style="overflow-y: scroll !important;">
                        {{item}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        </mat-cell>
        </ng-container>
        
    
          <!-- 12 Month Product Column -->
          <ng-container matColumnDef="12MonthProduct">
            <mat-header-cell *matHeaderCellDef mat-sort-header="12MonthProduct">12 Month Product</mat-header-cell>
            <mat-cell *matCellDef="let dataField let i=index">
              <div class="col-xl-12">
                <mat-form-field appearance="fill" hideRequiredMarker>
                  <mat-label>12 Month Product</mat-label>
                  <mat-select [(ngModel)]="dataField.MonthProduct" [ngModelOptions]="{standalone: true}"  placeholder="Select 12 Month Product">
                    <mat-select-filter    [displayMember]="'value'" [array]="MonthProducts" (filteredReturn)="filteredListMonthProduct = $event"></mat-select-filter>
                    
                    <!-- Populate with monthlyProduct if condition matches -->
                    <mat-option *ngFor="let item of filteredListMonthProduct" 
                                [value]="item">
                      {{item}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-cell>
          </ng-container>
    
          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <div class="text-truncate text-center">
                <i style="cursor: pointer;font-size: 25px;color: #9B02DB;" class="fa fa-save mr-3" (click)="save(dataField.VumatelProduct,dataField.productid,dataField.VumatelBaseProduct,dataField.MonthProduct)"></i>
              </div>
            </mat-cell>
          </ng-container>
    
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple></mat-row>
        </mat-table>
      </form>
    </div>
    
  </div>
</div>